import { UserService } from './../../../../../../shared/services/user.service';
import { XPartnerService } from './../../../../../../shared/services/x-partner.service';
import { DOCUMENT } from '@angular/common';
import { ChangeDetectorRef, Component, HostBinding, OnDestroy, OnInit, Inject } from '@angular/core';
import { BasePanelService } from '@modules/base-panel/pages/base-panel/services/base-panel.service';
import { filter } from 'rxjs/operators';
import { NavigationEnd, Router } from '@angular/router';
import { Subscription } from 'rxjs';

@Component({
  selector: 'df-base-left-side-navigation',
  templateUrl: './base-left-side-navigation.component.html',
  styleUrls: ['./base-left-side-navigation.component.scss'],
})
export class BaseLeftSideNavigationComponent implements OnInit, OnDestroy {
  sub: Subscription = new Subscription();
  openMobileNavigation = false;

  @HostBinding('class.mobileOpened')
  get mobileOpened() {
    this.openMobileNavigation
      ? this.document.body.classList.remove('menuMobileHidden')
      : this.document.body.classList.add('menuMobileHidden');
    return this.openMobileNavigation;
  }

  @HostBinding('class')
  get backgroundColor() {
    return this.xPartnerService.partner.MENU_CLASS;
  }

  constructor(
    public basePanelService: BasePanelService,
    public xPartnerService: XPartnerService,
    public userService: UserService,
    private changes: ChangeDetectorRef,
    private router: Router,
    @Inject(DOCUMENT) private document: Document,
  ) {}

  ngOnInit(): void {
    this.setRouterListener();
  }

  setRouterListener() {
    const sub = this.router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe(() => {
      this.closeMobileNavigation();
    });
    this.sub.add(sub);
  }

  toggleNavigation() {
    // clear NewUserRegistered after the first toggling menu by the user
    this.userService.isNewUserRegistered() ? this.userService.clearNewUserRegistered() : null;

    this.basePanelService.setShortLeftNavigation(!this.basePanelService.routeData.shortLeftNavigation, true);
    this.basePanelService.userSetNavigation = this.basePanelService.routeData.shortLeftNavigation!;
    this.changes.detectChanges();
  }

  toggleMobileNavigation() {
    this.openMobileNavigation = !this.openMobileNavigation;
    this.changes.detectChanges();
  }

  closeMobileNavigation() {
    this.openMobileNavigation = false;
    this.changes.detectChanges();
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }
}
